export class PromoteSet {

  public constructor(init?: Partial<PromoteSet>) {
    Object.assign(this, init);
  }

  disId = '';
  area = '';
  notPromoted: boolean;
  toPreProd: boolean;
  toProd: boolean;
  from: Date;
  to: Date;
}

export class PromoteFilter {
  notPromoted: boolean;
  toPreProd: boolean;
  toProd: boolean;
  disId = '';
  from: Date;
  to: Date;
}

export class StaticPromoteSet {

  public constructor(init?: Partial<PromoteSet>) {
    Object.assign(this, init);
  }

  fileName = '';
  area = '';
  notPromoted: boolean;
  toPreProd: boolean;
  toProd: boolean;
  from: Date;
  to: Date;
}

export class StaticPromoteFilter {
  notPromoted: boolean;
  toPreProd: boolean;
  toProd: boolean;
  fileName = '';
  from: Date;
  to: Date;
}

export class PromoteDynamicDTO {
  disId = '';
  source = '';
  target = '';
}

export class PromoteStaticDTO {
  fileName = '';
  source = '';
  target = '';
}
